/* import * as types from "./mutation-types"; */

export default {
  jobs_list(state, new_value){
    state.jobs_list = new_value
  },
  current_work(state, new_value){
    state.current_work = new_value
  },
  details_work(state, new_value){
    state.details_work = new_value
  },
};
